/* tslint:disable */
/* eslint-disable */
/**
 * Контроль місій для FPV
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface OutputEwFrequencySuggestion
 */
export interface OutputEwFrequencySuggestion {
    /**
     * 
     * @type {string}
     * @memberof OutputEwFrequencySuggestion
     */
    label?: string;
    /**
     * 
     * @type {number}
     * @memberof OutputEwFrequencySuggestion
     */
    max?: number;
    /**
     * 
     * @type {number}
     * @memberof OutputEwFrequencySuggestion
     */
    min?: number;
    /**
     * 
     * @type {string}
     * @memberof OutputEwFrequencySuggestion
     */
    unit?: string;
    /**
     * 
     * @type {number}
     * @memberof OutputEwFrequencySuggestion
     */
    usageCount?: number;
}

/**
 * Check if a given object implements the OutputEwFrequencySuggestion interface.
 */
export function instanceOfOutputEwFrequencySuggestion(value: object): boolean {
    return true;
}

export function OutputEwFrequencySuggestionFromJSON(json: any): OutputEwFrequencySuggestion {
    return OutputEwFrequencySuggestionFromJSONTyped(json, false);
}

export function OutputEwFrequencySuggestionFromJSONTyped(json: any, ignoreDiscriminator: boolean): OutputEwFrequencySuggestion {
    if (json == null) {
        return json;
    }
    return {
        
        'label': json['label'] == null ? undefined : json['label'],
        'max': json['max'] == null ? undefined : json['max'],
        'min': json['min'] == null ? undefined : json['min'],
        'unit': json['unit'] == null ? undefined : json['unit'],
        'usageCount': json['usageCount'] == null ? undefined : json['usageCount'],
    };
}

export function OutputEwFrequencySuggestionToJSON(value?: OutputEwFrequencySuggestion | null): any {
    if (value == null) {
        return value;
    }
    return {
        
        'label': value['label'],
        'max': value['max'],
        'min': value['min'],
        'unit': value['unit'],
        'usageCount': value['usageCount'],
    };
}

